<template>
<div>
  <el-dialog
      title="过磅"
      :visible.sync="weighVisible"
      :close-on-click-modal="false"
      width="80%"
      center
      :before-close="closeadd"
    >
    <div class="topForm">
      <div>
        <div style="margin:30px 30px 20px 10px;">称重类型：</div>
        <div style="width:100px;">
          <el-radio-group v-model="weightType">
            <el-radio :label="1" style="margin:10px 30px 20px 20px;">毛重</el-radio>
            <el-radio :label="2" style="margin:0 30px 20px 20px;" :disabled = 'weightTypeDisabled'>皮重</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="margin:0 30px 20px 50px;text-align: center;">
        <div style="margin:30px 30px 20px 0;font-weight: 700;">本次称重</div>
        <div class="weigthBox">
          <span>{{poundWeight}}</span>
        </div>
        <div style="margin-top:10px;">
          <div>如有故障，请<span style="color:blue;">手动输入</span></div>
        </div>
        <div style="margin-top:10px;">
          <el-input v-model="wieghtInput" placeholder="请输入重量" size="mini" v-number-input.float="4" maxlength="50" style="width:130px;"></el-input> 吨
        </div>
      </div>
      <!-- <div style="margin:0 30px 20px 50px;text-align: center;" v-if="weightType == 2">
        <div style="margin:30px 30px 20px 0;font-weight: 700;">净重</div>
        <div class="weigthBoxB">
          <span>13.999</span>
        </div>
      </div> -->
    </div>
    <div class="bottomTable">
    <div class="detailsTitle">
      <h4>货物信息</h4>
      <el-button style="position:absolute;left:110px;" type="primary" @click="refreshClick">刷新</el-button>
      <el-button style="position:absolute;left:170px;" type="primary" @click="getLatestInTareWeightInfoClick" :disabled="TwoIsDisable">同步上次皮重</el-button>
      <div style="position:absolute;left:310px;margin-top:5px;">{{chepai}}</div>
    </div>
    <el-table
      min-height="300px"
      max-height="350px"
      size="mini" border
      center bordersize="mini"
      ref="tableList"
      :data="tableList"
      style="width: 100%"
      highlight-current-row
      @row-click="dianjixuanzhong"
      :row-class-name="tableRowClassName"
      class="elTab">
      <el-table-column prop="productTypeName" label="货物类型" align="center"></el-table-column>
      <el-table-column prop="steelMillName" label="产地" align="center"></el-table-column>
      <el-table-column prop="specification" label="规格" align="center" width="130"></el-table-column>
      <el-table-column prop="model" label="材质" align="center" width="130"></el-table-column>
      <el-table-column prop="number" label="件数" align="center"></el-table-column>
      <el-table-column prop="grossWeight" label="毛重(吨)" align="center" ></el-table-column>
      <el-table-column prop="grossWeightTime" label="毛重时间" align="center" width="180" :formatter="dateTimeFormat"></el-table-column>
      <el-table-column prop="tareWeight" label="皮重(吨)" align="center" ></el-table-column>
      <el-table-column prop="tareWeightTime" label="皮重时间" align="center" width="180" :formatter="dateTimeFormat"></el-table-column>
      <el-table-column prop="weightingWeight" label="净重(吨)" align="center" ></el-table-column>
      <el-table-column prop="forecastSingletonWeight" label="预报件重" align="center" ></el-table-column>
      <el-table-column prop="warehouseName" label="仓位" align="center" ></el-table-column>
    </el-table>
    </div>
    <div slot="footer" style="width: 220px; margin: 15px auto">
      <el-button @click="closeadd">取 消</el-button>
      <el-button type="primary" :loading="Loading" @click="addDialog" :disabled='addDisabled'>保存</el-button>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getInWeightInfoList,
  calculateWeight, // 刷新调接口
  shipStockWeight, // 过磅保存
  getPoundWeight, // 连接过磅实时数据
  getLatestInTareWeightInfo
} from '@/api/wms-access'
import { dateTimeFormat } from '@/utils/util.js'
import DonMessage from '@/utils/message'
export default {
  name: 'xieCheDialog',
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      tableList: [],
      warehouseOptions: [],
      Loading: false,
      weightType: 0,
      wieghtInput: '',
      xuanzhongArr: null,
      addDisabled: true,
      instockid: '',
      weightTypeDisabled: false,
      flagA: true,
      poundWeight: 0,
      _inter: null,
      allWeight: '',
      TwoIsDisable: false
    }
  },
  props: {
    weighVisible: {
      type: Boolean,
      default: false
    },
    chepai: {
      type: String,
      default: ''
    },
    instockId: {
      type: String
    },
    warehouseId: {
      type: String
    }
  },
  watch: {
    instockId: {
      immediate: true,
      handler (val) {
        this.instockid = val
      }
    }
  },
  created () {
    this.getInWeightInfoList()
    this.interval()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
      }
    }
  },
  methods: {
    interval () {
      this._inter = setInterval(() => {
        this.getPoundWeight()
      }, 1000)
    },
    // 磅单为0 展示手写重量，磅单手写同时有展示手写重量
    getPoundWeight () {
      getPoundWeight()
        .then(res => {
          this.poundWeight = res
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    timeStamp2: function (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    getInWeightInfoList () {
      getInWeightInfoList(this.instockid)
        .then(res => {
          if (res.length != 0) {
            this.tableList = res
            // 判断是否有毛重，没有毛重显示毛重，有毛重显示皮重
            if (this.tableList[0].grossWeight) {
              this.weightType = 2
              this.weightTypeDisabled = false
              this.flagA = true
            } else {
              this.weightType = 1
              this.weightTypeDisabled = true
              this.flagA = false
            }
          }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    closeDialogFile () {
      this.Loading = false
    },
    closeadd () {
      this.$emit('update:weighVisible', false)
      this.$route.params.id = ''
      clearInterval(this._inter)
    },
    addDialog (params) {
      this.shipStockWeight(this.tableList)
    },
    shipStockWeight (params) {
      shipStockWeight(params).then(res => {
        DonMessage.success('保存成功')
        this.wieghtInput = ''
        this.$route.params.id = ''
        this.closeadd()
        this.$parent.chaxun()
      })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    tableRowClassName ({ row, rowIndex }) {
      // row.index = rowIndex
      this.$set(row, 'index', rowIndex)
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    // 点击刷新
    async refreshClick () {
      // 磅单为0 展示手写重量，磅单手写同时有展示手写重量
      let weightFlag = ''
      if (this.weightType == '1') {
        weightFlag = '毛重'
        if (this.wieghtInput == '' && this.poundWeight == '0') {
          DonMessage.error('请填写重量')
        } else {
          if (this.wieghtInput != '' && this.poundWeight != '0') {
            this.allWeight = this.wieghtInput
          } else if (this.wieghtInput != '' && this.poundWeight == '0') {
            this.allWeight = this.wieghtInput
          } else if (this.poundWeight != '0') {
            this.allWeight = this.poundWeight
          }
          if (this.flagA) {
            if (this.xuanzhongArr == null) {
              DonMessage.error('请先选择一条数据')
            } else {
              let params = {
                index: this.xuanzhongArr.index, // 索引,
                weight: this.allWeight, // 重量，（毛重重量或皮重重量，保留三位小数）
                weightFlag: weightFlag, // 毛重或皮重的标识，
                operator: localStorage.getItem('userName'), // 操作人，
                list: this.tableList // 过磅页面回显的list数据
              }
              let res = await calculateWeight(params)
              this.tableList = res.list
              this.addDisabled = false
              this.xuanzhongArr = null
            }
          } else {
            calculateWeight({
              // index: this.xuanzhongArr.index, // 索引,
              weight: this.allWeight, // 重量，（毛重重量或皮重重量，保留三位小数）
              weightFlag: weightFlag, // 毛重或皮重的标识，
              operator: localStorage.getItem('userName'), // 操作人，
              list: this.tableList // 过磅页面回显的list数据
            }).then(res => {
              this.tableList = res.list
              this.addDisabled = false
            })
              .catch(err => {
                DonMessage.error(err.message)
              })
          }
        }
      } else {
        weightFlag = '皮重'
        if (this.wieghtInput == '' && this.poundWeight == '0') {
          DonMessage.error('请填写重量')
        } else if (this.xuanzhongArr != null) {
          if (this.wieghtInput != '' && this.poundWeight != '0') {
            this.allWeight = this.wieghtInput
          } else if (this.wieghtInput != '' && this.poundWeight == '0') {
            this.allWeight = this.wieghtInput
          } else if (this.poundWeight != '0') {
            this.allWeight = this.poundWeight
          }
          let params = {
            index: this.xuanzhongArr.index, // 索引,
            weight: this.allWeight, // 重量，（毛重重量或皮重重量，保留三位小数）
            weightFlag: weightFlag, // 毛重或皮重的标识，
            operator: localStorage.getItem('userName'), // 操作人，
            list: this.tableList // 过磅页面回显的list数据
          }
          let res = await calculateWeight(params)
          this.tableList = JSON.parse(JSON.stringify(res.list))
          this.addDisabled = false
          // checkFlag：是否超过千分之三 0：没有，1：有
          if (this.weightType == '2') {
            if (res.checkFlag == '1') {
              // 提示：规格**过磅净重**吨，超过预报件重**吨的千分之三
              this.$confirm('规格 ' + this.tableList[this.xuanzhongArr.index].specification + ' 过磅件重 ' + (this.tableList[this.xuanzhongArr.index].weightingWeight / this.tableList[this.xuanzhongArr.index].number).toFixed(4) + ' 吨，' + '超过预报件重 ' + this.tableList[this.xuanzhongArr.index].forecastSingletonWeight + '吨的千分之三，是否保存？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.shipStockWeight(this.tableList)
              }).catch(() => {
              })
            }
          }
          this.xuanzhongArr = null
        } else {
          DonMessage.error('请先选择一条数据')
        }
      }
    },
    // 点击同步皮重
    getLatestInTareWeightInfoClick () {
      if (this.flagA) {
        DonMessage.error('已过毛重，不能同步')
      } else {
        getLatestInTareWeightInfo({
          instockPlateNumber: this.chepai // 入库车牌号
        }).then(res => {
          // 获取到的皮重和皮重时间，更新现在的毛重和毛重时间
          // tareWeight 皮重  tareWeightTime 皮重时间 grossWeight 毛重 grossWeightTime毛重时间
          this.$confirm('已查询到上次皮重数据，是否同步？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.tableList.forEach(item => {
              this.$set(item, 'grossWeight', res.tareWeight)
              this.$set(item, 'grossWeightTime', res.tareWeightTime)
              this.addDisabled = false
            })
          }).catch(() => {
          })
          this.TwoIsDisable = true
          setTimeout(() => {
            this.TwoIsDisable = false // 点击一次时隔两秒后才能再次点击
          }, 2000)
        })
          .catch(err => {
            DonMessage.error(err.message)
          })
      }
    }
  },
  mounted () {
  }

}
</script>

<style lang="less" scoped>
.topForm{
  display: flex;
}
.weigthBox{
  width: 160px;
  height: 120px;
  border: dashed 3px green;
  text-align: center;
  line-height: 120px;
  font-size: 24px;
  font-weight: 700;
  color: red;
  background-color: #f6f6f6;
}
.weigthBoxB{
  width: 160px;
  height: 120px;
  border: dotted 3px #ccc;
  text-align: center;
  line-height: 120px;
  font-size: 24px;
  font-weight: 700;
  background-color: #f6f6f6;
}
</style>
